import {closeWebView} from '@zzng/common/scheme/web';

import {useCardGroupStore} from '@/root/stores/cardGroup';

import PageLayout from '@/shared/components/PageLayout';
import {PAGE_NAME, STATUS_BAR_COLOR} from '@/shared/constants/statusBarColor';
import {TIARA_DETAIL_ACTION, TIARA_DETAIL_PAGE_NAME} from '@/shared/constants/tiara';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';

import {ROUTES} from '@/apps/root/constants/routes';
import {useUiStore} from '@/apps/root/stores/ui';

const CardNotFound = () => {
  const {groupCode, cardId} = useCardGroupStore();
  const navigate = useAdvancedNavigate();
  const isFromHome = useUiStore((state) => state.isFromHome);

  const onClickClose = () => {
    if (isFromHome) {
      navigate(ROUTES.HOME, {replace: true, transitionDirection: 'back'});
      return;
    }

    closeWebView();
  };

  return (
    <PageLayout
      tiara={{
        pageName: TIARA_DETAIL_PAGE_NAME.CARD_DETAIL,
        pageAction: TIARA_DETAIL_ACTION.CARD_NOT_FOUND_VIEW,
        customProps: {
          ...(groupCode && {group_code: groupCode}),
          ...(cardId && {card_id: cardId})
        }
      }}
      headerProps={{buttons: [{type: 'CLOSE', onClick: onClickClose}]}}
      statusBarColor={{default: STATUS_BAR_COLOR[PAGE_NAME.CARD_NOT_FOUND]}}
      className="container-bridge"
      articleClassName="content-full"
    >
      <div className="inner_g">
        <div className="group_empty type2">
          <strong className="tit_g">
            <span className="item_txt" role="text">
              <span className="txt_tit">보유한 디지털카드가 없습니다</span>
            </span>
          </strong>
          <p className="txt_g">
            삭제하거나 회수된
            <br /> 디지털카드는 이용할 수 없습니다.
          </p>
        </div>
      </div>
    </PageLayout>
  );
};
export default CardNotFound;
